import FormCheckbox from 'components/common/forms/FormCheckbox';
import {
  DiseaseLabel,
  DiseaseName,
  MedicalHistoryChartFields,
} from 'constants/chart/medicalHistoryChart';
import { STYLES_VARIABLES } from 'constants/styleVariables';
import { useFormContext, useWatch } from 'react-hook-form';
import { TMedicalHistoryChartFormValues } from 'types/chart/medicalHistoryChart';

type TProps = {
  isRegister: boolean;
};

const DiseaseExperience = ({ isRegister }: TProps) => {
  const { control, setValue } =
    useFormContext<TMedicalHistoryChartFormValues>();
  const experienceDiseaseMain = useWatch({
    name: MedicalHistoryChartFields.DiseaseExperience,
    control,
  });

  return (
    <div className="mt24">
      <FormCheckbox
        id={DiseaseName.심혈관질환}
        name={MedicalHistoryChartFields.DiseaseExperience}
        text={DiseaseLabel[DiseaseName.심혈관질환]}
        labelStyle={{ fontWeight: '700', paddingLeft: '0' }}
        value={DiseaseName.심혈관질환}
        multiple={true}
        afterChange={(value) => {
          const valueAsArray = value as string[];
          if (!valueAsArray.includes(DiseaseName.심혈관질환)) {
            const filteredValues = experienceDiseaseMain?.filter(
              (disease) =>
                disease !== DiseaseName.심혈관질환 &&
                disease !== DiseaseName.고혈압 &&
                disease !== DiseaseName.저혈압 &&
                disease !== DiseaseName.부정맥 &&
                disease !== DiseaseName.심혈관질환_선천성심장질환 &&
                disease !== DiseaseName.울혈성신부전 &&
                disease !== DiseaseName.심박동조율기
            );

            setValue(
              MedicalHistoryChartFields.DiseaseExperience,
              filteredValues
            );
          }
        }}
        readOnly={!isRegister}
      />
      <span
        style={{
          color: STYLES_VARIABLES.GRAY_08,
          verticalAlign: 'top',
          lineHeight: '24px',
        }}
        className="mr8"
      >
        &#91;
      </span>
      <FormCheckbox
        id={DiseaseLabel[DiseaseName.고혈압]}
        name={MedicalHistoryChartFields.DiseaseExperience}
        text={DiseaseLabel[DiseaseName.고혈압]}
        labelStyle={{
          color: STYLES_VARIABLES.GRAY_08,
          marginRight: '6px',
          paddingLeft: '0',
        }}
        value={
          !experienceDiseaseMain?.includes(DiseaseName.심혈관질환)
            ? ''
            : DiseaseName.고혈압
        }
        disabled={!experienceDiseaseMain?.includes(DiseaseName.심혈관질환)}
        multiple={true}
        readOnly={!isRegister}
      />
      <FormCheckbox
        id={DiseaseLabel[DiseaseName.저혈압]}
        name={MedicalHistoryChartFields.DiseaseExperience}
        text={DiseaseLabel[DiseaseName.저혈압]}
        labelStyle={{ color: STYLES_VARIABLES.GRAY_08, marginRight: '6px' }}
        value={
          !experienceDiseaseMain?.includes(DiseaseName.심혈관질환)
            ? ''
            : DiseaseName.저혈압
        }
        disabled={!experienceDiseaseMain?.includes(DiseaseName.심혈관질환)}
        multiple={true}
        readOnly={!isRegister}
      />

      <FormCheckbox
        id={DiseaseLabel[DiseaseName.부정맥]}
        name={MedicalHistoryChartFields.DiseaseExperience}
        text={DiseaseLabel[DiseaseName.부정맥]}
        labelStyle={{ color: STYLES_VARIABLES.GRAY_08, marginRight: '6px' }}
        value={
          !experienceDiseaseMain?.includes(DiseaseName.심혈관질환)
            ? ''
            : DiseaseName.부정맥
        }
        disabled={!experienceDiseaseMain?.includes(DiseaseName.심혈관질환)}
        multiple={true}
        readOnly={!isRegister}
      />
      <FormCheckbox
        id={DiseaseLabel[DiseaseName.심혈관질환_선천성심장질환]}
        name={MedicalHistoryChartFields.DiseaseExperience}
        text={DiseaseLabel[DiseaseName.심혈관질환_선천성심장질환]}
        labelStyle={{ color: STYLES_VARIABLES.GRAY_08, marginRight: '6px' }}
        value={
          !experienceDiseaseMain?.includes(DiseaseName.심혈관질환)
            ? ''
            : DiseaseName.심혈관질환_선천성심장질환
        }
        disabled={!experienceDiseaseMain?.includes(DiseaseName.심혈관질환)}
        multiple={true}
        readOnly={!isRegister}
      />
      <FormCheckbox
        id={DiseaseLabel[DiseaseName.울혈성신부전]}
        name={MedicalHistoryChartFields.DiseaseExperience}
        text={DiseaseLabel[DiseaseName.울혈성신부전]}
        labelStyle={{ color: STYLES_VARIABLES.GRAY_08, marginRight: '6px' }}
        value={
          !experienceDiseaseMain?.includes(DiseaseName.심혈관질환)
            ? ''
            : DiseaseName.울혈성신부전
        }
        disabled={!experienceDiseaseMain?.includes(DiseaseName.심혈관질환)}
        multiple={true}
        readOnly={!isRegister}
      />
      <FormCheckbox
        id={DiseaseLabel[DiseaseName.심박동조율기]}
        name={MedicalHistoryChartFields.DiseaseExperience}
        text={DiseaseLabel[DiseaseName.심박동조율기]}
        labelStyle={{
          color: STYLES_VARIABLES.GRAY_08,
          marginRight: '8px',
          paddingRight: '0',
        }}
        value={
          !experienceDiseaseMain?.includes(DiseaseName.심혈관질환)
            ? ''
            : DiseaseName.심박동조율기
        }
        disabled={!experienceDiseaseMain?.includes(DiseaseName.심혈관질환)}
        multiple={true}
        readOnly={!isRegister}
      />
      <span
        style={{
          color: STYLES_VARIABLES.GRAY_08,
          verticalAlign: 'top',
          lineHeight: '24px',
        }}
        className="inline_flex items_center "
      >
        &#93;
      </span>

      <FormCheckbox
        id={DiseaseName.당뇨병}
        name={MedicalHistoryChartFields.DiseaseExperience}
        text={DiseaseLabel[DiseaseName.당뇨병]}
        labelStyle={{
          fontWeight: '700',
          paddingLeft: '0',
        }}
        value={DiseaseName.당뇨병}
        multiple={true}
        readOnly={!isRegister}
      />

      <FormCheckbox
        name={MedicalHistoryChartFields.DiseaseExperience}
        text={DiseaseLabel[DiseaseName.갑상선질환]}
        labelStyle={{ fontWeight: '700' }}
        value={DiseaseName.갑상선질환}
        multiple={true}
        afterChange={(value) => {
          const valueAsArray = value as string[];
          if (!valueAsArray.includes(DiseaseName.갑상선질환)) {
            const filteredValues = experienceDiseaseMain?.filter(
              (disease) =>
                disease !== DiseaseName.갑상선질환 &&
                disease !== DiseaseName.항진증 &&
                disease !== DiseaseName.부전증
            );

            setValue(
              MedicalHistoryChartFields.DiseaseExperience,
              filteredValues
            );
          }
        }}
        readOnly={!isRegister}
      />

      <span
        style={{
          color: STYLES_VARIABLES.GRAY_08,
          verticalAlign: 'top',
          lineHeight: '24px',
        }}
        className="mr8"
      >
        &#91;
      </span>
      <FormCheckbox
        name={MedicalHistoryChartFields.DiseaseExperience}
        text={DiseaseLabel[DiseaseName.항진증]}
        labelStyle={{
          color: STYLES_VARIABLES.GRAY_08,
          marginRight: '6px',
          paddingLeft: '0',
        }}
        value={DiseaseName.항진증}
        disabled={!experienceDiseaseMain?.includes(DiseaseName.갑상선질환)}
        multiple={true}
        readOnly={!isRegister}
      />
      <FormCheckbox
        name={MedicalHistoryChartFields.DiseaseExperience}
        text={DiseaseLabel[DiseaseName.부전증]}
        labelStyle={{
          color: STYLES_VARIABLES.GRAY_08,
          marginRight: '8px',
          paddingRight: '0',
        }}
        value={DiseaseName.부전증}
        disabled={!experienceDiseaseMain?.includes(DiseaseName.갑상선질환)}
        multiple={true}
        readOnly={!isRegister}
      />
      <span
        style={{
          color: STYLES_VARIABLES.GRAY_08,
          verticalAlign: 'top',
          lineHeight: '24px',
          marginRight: '360px',
        }}
      >
        &#93;
      </span>

      <FormCheckbox
        name={MedicalHistoryChartFields.DiseaseExperience}
        text={DiseaseLabel[DiseaseName.호흡기질환]}
        labelStyle={{ fontWeight: '700', paddingLeft: '0' }}
        value={DiseaseName.호흡기질환}
        multiple={true}
        afterChange={(value) => {
          const valueAsArray = value as string[];
          if (!valueAsArray.includes(DiseaseName.호흡기질환)) {
            const filteredValues = experienceDiseaseMain?.filter(
              (disease) =>
                disease !== DiseaseName.호흡기질환 &&
                disease !== DiseaseName.천식 &&
                disease !== DiseaseName.기관지염 &&
                disease !== DiseaseName.만성폐색성폐질환
            );

            setValue(
              MedicalHistoryChartFields.DiseaseExperience,
              filteredValues
            );
          }
        }}
        readOnly={!isRegister}
      />

      <span
        style={{
          color: STYLES_VARIABLES.GRAY_08,
          verticalAlign: 'top',
          lineHeight: '24px',
        }}
        className="mr8"
      >
        &#91;
      </span>
      <FormCheckbox
        name={MedicalHistoryChartFields.DiseaseExperience}
        text={DiseaseLabel[DiseaseName.천식]}
        labelStyle={{
          color: STYLES_VARIABLES.GRAY_08,
          marginRight: '6px',
          paddingLeft: '0',
        }}
        value={DiseaseName.천식}
        disabled={!experienceDiseaseMain?.includes(DiseaseName.호흡기질환)}
        multiple={true}
        readOnly={!isRegister}
      />
      <FormCheckbox
        name={MedicalHistoryChartFields.DiseaseExperience}
        text={DiseaseLabel[DiseaseName.기관지염]}
        labelStyle={{ color: STYLES_VARIABLES.GRAY_08, marginRight: '6px' }}
        value={DiseaseName.기관지염}
        disabled={!experienceDiseaseMain?.includes(DiseaseName.호흡기질환)}
        multiple={true}
        readOnly={!isRegister}
      />
      <FormCheckbox
        name={MedicalHistoryChartFields.DiseaseExperience}
        text={DiseaseLabel[DiseaseName.만성폐색성폐질환]}
        labelStyle={{
          color: STYLES_VARIABLES.GRAY_08,
          marginRight: '8px',
          paddingRight: '0',
        }}
        value={DiseaseName.만성폐색성폐질환}
        disabled={!experienceDiseaseMain?.includes(DiseaseName.호흡기질환)}
        multiple={true}
        readOnly={!isRegister}
      />
      <span
        style={{
          color: STYLES_VARIABLES.GRAY_08,
          verticalAlign: 'top',
          lineHeight: '24px',
          marginRight: '360px',
        }}
      >
        &#93;
      </span>

      <FormCheckbox
        name={MedicalHistoryChartFields.DiseaseExperience}
        text={DiseaseLabel[DiseaseName.심장질환]}
        labelStyle={{ fontWeight: '700', paddingLeft: '0' }}
        value={DiseaseName.심장질환}
        multiple={true}
        afterChange={(value) => {
          const valueAsArray = value as string[];
          if (!valueAsArray.includes(DiseaseName.심장질환)) {
            const filteredValues = experienceDiseaseMain?.filter(
              (disease) =>
                disease !== DiseaseName.심장질환 &&
                disease !== DiseaseName.인공심장판막 &&
                disease !== DiseaseName.감염성심내막염 &&
                disease !== DiseaseName.심장질환_선천성심장질환 &&
                disease !== DiseaseName.심장이식
            );

            setValue(
              MedicalHistoryChartFields.DiseaseExperience,
              filteredValues
            );
          }
        }}
        readOnly={!isRegister}
      />

      <span
        style={{
          color: STYLES_VARIABLES.GRAY_08,
          verticalAlign: 'top',
          lineHeight: '24px',
        }}
        className="mr8"
      >
        &#91;
      </span>
      <FormCheckbox
        name={MedicalHistoryChartFields.DiseaseExperience}
        text={DiseaseLabel[DiseaseName.인공심장판막]}
        labelStyle={{
          color: STYLES_VARIABLES.GRAY_08,
          marginRight: '6px',
          paddingLeft: '0',
        }}
        value={DiseaseName.인공심장판막}
        disabled={!experienceDiseaseMain?.includes(DiseaseName.심장질환)}
        multiple={true}
        readOnly={!isRegister}
      />
      <FormCheckbox
        name={MedicalHistoryChartFields.DiseaseExperience}
        text={DiseaseLabel[DiseaseName.감염성심내막염]}
        labelStyle={{ color: STYLES_VARIABLES.GRAY_08, marginRight: '6px' }}
        value={DiseaseName.감염성심내막염}
        disabled={!experienceDiseaseMain?.includes(DiseaseName.심장질환)}
        multiple={true}
        readOnly={!isRegister}
      />
      <FormCheckbox
        name={MedicalHistoryChartFields.DiseaseExperience}
        text={DiseaseLabel[DiseaseName.심장질환_선천성심장질환]}
        labelStyle={{ color: STYLES_VARIABLES.GRAY_08, marginRight: '6px' }}
        value={DiseaseName.심장질환_선천성심장질환}
        disabled={!experienceDiseaseMain?.includes(DiseaseName.심장질환)}
        multiple={true}
        readOnly={!isRegister}
      />
      <FormCheckbox
        name={MedicalHistoryChartFields.DiseaseExperience}
        text={DiseaseLabel[DiseaseName.심장이식]}
        labelStyle={{
          color: STYLES_VARIABLES.GRAY_08,
          marginRight: '8px',
          paddingRight: '0',
        }}
        value={DiseaseName.심장이식}
        disabled={!experienceDiseaseMain?.includes(DiseaseName.심장질환)}
        multiple={true}
        readOnly={!isRegister}
      />
      <span
        style={{
          color: STYLES_VARIABLES.GRAY_08,
          verticalAlign: 'top',
          lineHeight: '24px',
          marginRight: '150px',
        }}
      >
        &#93;
      </span>

      <FormCheckbox
        name={MedicalHistoryChartFields.DiseaseExperience}
        text={DiseaseLabel[DiseaseName.면역질환]}
        labelStyle={{ fontWeight: '700', paddingLeft: '0' }}
        value={DiseaseName.면역질환}
        multiple={true}
        afterChange={(value) => {
          const valueAsArray = value as string[];
          if (!valueAsArray.includes(DiseaseName.면역질환)) {
            const filteredValues = experienceDiseaseMain?.filter(
              (disease) =>
                disease !== DiseaseName.면역질환 &&
                disease !== DiseaseName.면역질환_에이즈 &&
                disease !== DiseaseName.백혈병 &&
                disease !== DiseaseName.암 &&
                disease !== DiseaseName.화학요법약복용 &&
                disease !== DiseaseName.면역억제제복용
            );

            setValue(
              MedicalHistoryChartFields.DiseaseExperience,
              filteredValues
            );
          }
        }}
        readOnly={!isRegister}
      />
      <span
        style={{
          color: STYLES_VARIABLES.GRAY_08,
          verticalAlign: 'top',
          lineHeight: '24px',
        }}
        className="mr8"
      >
        &#91;
      </span>
      <FormCheckbox
        name={MedicalHistoryChartFields.DiseaseExperience}
        text={DiseaseLabel[DiseaseName.면역질환_에이즈]}
        labelStyle={{
          color: STYLES_VARIABLES.GRAY_08,
          marginRight: '6px',
          paddingLeft: '0',
        }}
        value={DiseaseName.면역질환_에이즈}
        disabled={!experienceDiseaseMain?.includes(DiseaseName.면역질환)}
        multiple={true}
        readOnly={!isRegister}
      />
      <FormCheckbox
        name={MedicalHistoryChartFields.DiseaseExperience}
        text={DiseaseLabel[DiseaseName.백혈병]}
        labelStyle={{ color: STYLES_VARIABLES.GRAY_08, marginRight: '6px' }}
        value={DiseaseName.백혈병}
        disabled={!experienceDiseaseMain?.includes(DiseaseName.면역질환)}
        multiple={true}
        readOnly={!isRegister}
      />
      <FormCheckbox
        name={MedicalHistoryChartFields.DiseaseExperience}
        text={DiseaseLabel[DiseaseName.암]}
        labelStyle={{ color: STYLES_VARIABLES.GRAY_08, marginRight: '6px' }}
        value={DiseaseName.암}
        disabled={!experienceDiseaseMain?.includes(DiseaseName.면역질환)}
        multiple={true}
        readOnly={!isRegister}
      />
      <FormCheckbox
        name={MedicalHistoryChartFields.DiseaseExperience}
        text={DiseaseLabel[DiseaseName.화학요법약복용]}
        labelStyle={{ color: STYLES_VARIABLES.GRAY_08, marginRight: '6px' }}
        value={DiseaseName.화학요법약복용}
        disabled={!experienceDiseaseMain?.includes(DiseaseName.면역질환)}
        multiple={true}
        readOnly={!isRegister}
      />
      <FormCheckbox
        name={MedicalHistoryChartFields.DiseaseExperience}
        text={DiseaseLabel[DiseaseName.면역억제제복용]}
        labelStyle={{
          color: STYLES_VARIABLES.GRAY_08,
          marginRight: '8px',
          paddingRight: '0',
        }}
        value={DiseaseName.면역억제제복용}
        disabled={!experienceDiseaseMain?.includes(DiseaseName.면역질환)}
        multiple={true}
        readOnly={!isRegister}
      />
      <span
        style={{
          color: STYLES_VARIABLES.GRAY_08,
          verticalAlign: 'top',
          lineHeight: '24px',
        }}
        className="mr32"
      >
        &#93;
      </span>

      <FormCheckbox
        name={MedicalHistoryChartFields.DiseaseExperience}
        text={DiseaseLabel[DiseaseName.출혈질환]}
        labelStyle={{ fontWeight: '700', paddingLeft: '0' }}
        value={DiseaseName.출혈질환}
        multiple={true}
        afterChange={(value) => {
          const valueAsArray = value as string[];
          if (!valueAsArray.includes(DiseaseName.출혈질환)) {
            const filteredValues = experienceDiseaseMain?.filter(
              (disease) =>
                disease !== DiseaseName.출혈질환 &&
                disease !== DiseaseName.빈혈 &&
                disease !== DiseaseName.혈우병 &&
                disease !== DiseaseName.항응고제복용
            );

            setValue(
              MedicalHistoryChartFields.DiseaseExperience,
              filteredValues
            );
          }
        }}
        readOnly={!isRegister}
      />

      <span
        style={{
          color: STYLES_VARIABLES.GRAY_08,
          verticalAlign: 'top',
          lineHeight: '24px',
        }}
        className="mr8"
      >
        &#91;
      </span>
      <FormCheckbox
        name={MedicalHistoryChartFields.DiseaseExperience}
        text={DiseaseLabel[DiseaseName.빈혈]}
        labelStyle={{
          color: STYLES_VARIABLES.GRAY_08,
          marginRight: '6px',
          paddingLeft: '0',
        }}
        value={DiseaseName.빈혈}
        disabled={!experienceDiseaseMain?.includes(DiseaseName.출혈질환)}
        multiple={true}
        readOnly={!isRegister}
      />
      <FormCheckbox
        name={MedicalHistoryChartFields.DiseaseExperience}
        text={DiseaseLabel[DiseaseName.혈우병]}
        labelStyle={{ color: STYLES_VARIABLES.GRAY_08, marginRight: '6px' }}
        value={DiseaseName.혈우병}
        disabled={!experienceDiseaseMain?.includes(DiseaseName.출혈질환)}
        multiple={true}
        readOnly={!isRegister}
      />
      <FormCheckbox
        name={MedicalHistoryChartFields.DiseaseExperience}
        text={DiseaseLabel[DiseaseName.항응고제복용]}
        labelStyle={{
          color: STYLES_VARIABLES.GRAY_08,
          marginRight: '8px',
          paddingRight: '0',
        }}
        value={DiseaseName.항응고제복용}
        disabled={!experienceDiseaseMain?.includes(DiseaseName.출혈질환)}
        multiple={true}
        readOnly={!isRegister}
      />
      <span
        style={{
          color: STYLES_VARIABLES.GRAY_08,
          verticalAlign: 'top',
          lineHeight: '24px',
        }}
        className="mr32"
      >
        &#93;
      </span>

      <FormCheckbox
        name={MedicalHistoryChartFields.DiseaseExperience}
        text={DiseaseLabel[DiseaseName.신경계질환]}
        labelStyle={{ fontWeight: '700' }}
        value={DiseaseName.신경계질환}
        multiple={true}
        afterChange={(value) => {
          const valueAsArray = value as string[];
          if (!valueAsArray.includes(DiseaseName.신경계질환)) {
            const filteredValues = experienceDiseaseMain?.filter(
              (disease) =>
                disease !== DiseaseName.신경계질환 &&
                disease !== DiseaseName.뇌전증 &&
                disease !== DiseaseName.뇌졸중
            );

            setValue(
              MedicalHistoryChartFields.DiseaseExperience,
              filteredValues
            );
          }
        }}
        readOnly={!isRegister}
      />

      <span
        style={{
          color: STYLES_VARIABLES.GRAY_08,
          verticalAlign: 'top',
          lineHeight: '24px',
        }}
        className="mr8"
      >
        &#91;
      </span>
      <FormCheckbox
        name={MedicalHistoryChartFields.DiseaseExperience}
        text={DiseaseLabel[DiseaseName.뇌전증]}
        labelStyle={{
          color: STYLES_VARIABLES.GRAY_08,
          marginRight: '6px',
          paddingLeft: '0',
        }}
        value={DiseaseName.뇌전증}
        disabled={!experienceDiseaseMain?.includes(DiseaseName.신경계질환)}
        multiple={true}
        readOnly={!isRegister}
      />
      <FormCheckbox
        name={MedicalHistoryChartFields.DiseaseExperience}
        text={DiseaseLabel[DiseaseName.뇌졸중]}
        labelStyle={{
          color: STYLES_VARIABLES.GRAY_08,
          marginRight: '8px',
          paddingRight: '0',
        }}
        value={DiseaseName.뇌졸중}
        disabled={!experienceDiseaseMain?.includes(DiseaseName.신경계질환)}
        multiple={true}
        readOnly={!isRegister}
      />
      <span
        style={{
          color: STYLES_VARIABLES.GRAY_08,
          verticalAlign: 'top',
          lineHeight: '24px',
        }}
        className="mr32"
      >
        &#93;
      </span>

      <FormCheckbox
        name={MedicalHistoryChartFields.DiseaseExperience}
        text={DiseaseLabel[DiseaseName.간질환]}
        labelStyle={{ fontWeight: '700', paddingLeft: '0' }}
        value={DiseaseName.간질환}
        multiple={true}
        afterChange={(value) => {
          const valueAsArray = value as string[];
          if (!valueAsArray.includes(DiseaseName.간질환)) {
            const filteredValues = experienceDiseaseMain?.filter(
              (disease) =>
                disease !== DiseaseName.간질환 &&
                disease !== DiseaseName.황달 &&
                disease !== DiseaseName.간질환_A형간염 &&
                disease !== DiseaseName.간질환_B형간염 &&
                disease !== DiseaseName.C형간염
            );

            setValue(
              MedicalHistoryChartFields.DiseaseExperience,
              filteredValues
            );
          }
        }}
        readOnly={!isRegister}
      />

      <span
        style={{
          color: STYLES_VARIABLES.GRAY_08,
          verticalAlign: 'top',
          lineHeight: '24px',
        }}
        className="mr8"
      >
        &#91;
      </span>
      <FormCheckbox
        name={MedicalHistoryChartFields.DiseaseExperience}
        text={DiseaseLabel[DiseaseName.황달]}
        labelStyle={{
          color: STYLES_VARIABLES.GRAY_08,
          marginRight: '6px',
          paddingLeft: '0',
        }}
        value={DiseaseName.황달}
        disabled={!experienceDiseaseMain?.includes(DiseaseName.간질환)}
        multiple={true}
        readOnly={!isRegister}
      />
      <FormCheckbox
        name={MedicalHistoryChartFields.DiseaseExperience}
        text={DiseaseLabel[DiseaseName.간질환_A형간염]}
        labelStyle={{ color: STYLES_VARIABLES.GRAY_08, marginRight: '6px' }}
        value={DiseaseName.간질환_A형간염}
        disabled={!experienceDiseaseMain?.includes(DiseaseName.간질환)}
        multiple={true}
        readOnly={!isRegister}
      />
      <FormCheckbox
        name={MedicalHistoryChartFields.DiseaseExperience}
        text={DiseaseLabel[DiseaseName.간질환_B형간염]}
        labelStyle={{ color: STYLES_VARIABLES.GRAY_08, marginRight: '6px' }}
        value={DiseaseName.간질환_B형간염}
        disabled={!experienceDiseaseMain?.includes(DiseaseName.간질환)}
        multiple={true}
        readOnly={!isRegister}
      />
      <FormCheckbox
        name={MedicalHistoryChartFields.DiseaseExperience}
        text={DiseaseLabel[DiseaseName.C형간염]}
        labelStyle={{
          color: STYLES_VARIABLES.GRAY_08,
          marginRight: '8px',
          paddingRight: '0',
        }}
        value={DiseaseName.C형간염}
        disabled={!experienceDiseaseMain?.includes(DiseaseName.간질환)}
        multiple={true}
        readOnly={!isRegister}
      />
      <span
        style={{
          color: STYLES_VARIABLES.GRAY_08,
          verticalAlign: 'top',
          lineHeight: '24px',
        }}
        className="mr32"
      >
        &#93;
      </span>

      <FormCheckbox
        name={MedicalHistoryChartFields.DiseaseExperience}
        text={DiseaseLabel[DiseaseName.관절질환]}
        labelStyle={{ fontWeight: '700' }}
        value={DiseaseName.관절질환}
        multiple={true}
        afterChange={(value) => {
          const valueAsArray = value as string[];
          if (!valueAsArray.includes(DiseaseName.관절질환)) {
            const filteredValues = experienceDiseaseMain?.filter(
              (disease) =>
                disease !== DiseaseName.관절질환 &&
                disease !== DiseaseName.관절염 &&
                disease !== DiseaseName.류마티즘
            );

            setValue(
              MedicalHistoryChartFields.DiseaseExperience,
              filteredValues
            );
          }
        }}
        readOnly={!isRegister}
      />

      <span
        style={{
          color: STYLES_VARIABLES.GRAY_08,
          verticalAlign: 'top',
          lineHeight: '24px',
        }}
        className="mr8"
      >
        &#91;
      </span>
      <FormCheckbox
        name={MedicalHistoryChartFields.DiseaseExperience}
        text={DiseaseLabel[DiseaseName.관절염]}
        labelStyle={{
          color: STYLES_VARIABLES.GRAY_08,
          marginRight: '6px',
          paddingLeft: '0',
        }}
        value={DiseaseName.관절염}
        disabled={!experienceDiseaseMain?.includes(DiseaseName.관절질환)}
        multiple={true}
        readOnly={!isRegister}
      />
      <FormCheckbox
        name={MedicalHistoryChartFields.DiseaseExperience}
        text={DiseaseLabel[DiseaseName.류마티즘]}
        labelStyle={{
          color: STYLES_VARIABLES.GRAY_08,
          marginRight: '8px',
          paddingRight: '0',
        }}
        value={DiseaseName.류마티즘}
        disabled={!experienceDiseaseMain?.includes(DiseaseName.관절질환)}
        multiple={true}
        readOnly={!isRegister}
      />
      <span
        style={{
          color: STYLES_VARIABLES.GRAY_08,
          verticalAlign: 'top',
          lineHeight: '24px',
        }}
      >
        &#93;
      </span>

      <FormCheckbox
        name={MedicalHistoryChartFields.DiseaseExperience}
        text={DiseaseLabel[DiseaseName.감염성질환]}
        labelStyle={{ fontWeight: '700', paddingLeft: '0' }}
        value={DiseaseName.감염성질환}
        multiple={true}
        afterChange={(value) => {
          const valueAsArray = value as string[];
          if (!valueAsArray.includes(DiseaseName.감염성질환)) {
            const filteredValues = experienceDiseaseMain?.filter(
              (disease) =>
                disease !== DiseaseName.감염성질환 &&
                disease !== DiseaseName.결핵 &&
                disease !== DiseaseName.감염성질환_A형간염 &&
                disease !== DiseaseName.감염성질환_B형간염 &&
                disease !== DiseaseName.감염성질환_에이즈 &&
                disease !== DiseaseName.포진 &&
                disease !== DiseaseName.유행성감기
            );

            setValue(
              MedicalHistoryChartFields.DiseaseExperience,
              filteredValues
            );
          }
        }}
        readOnly={!isRegister}
      />

      <span
        style={{
          color: STYLES_VARIABLES.GRAY_08,
          verticalAlign: 'top',
          lineHeight: '24px',
        }}
        className="mr8"
      >
        &#91;
      </span>
      <FormCheckbox
        name={MedicalHistoryChartFields.DiseaseExperience}
        text={DiseaseLabel[DiseaseName.결핵]}
        labelStyle={{
          color: STYLES_VARIABLES.GRAY_08,
          marginRight: '6px',
          paddingLeft: '0',
        }}
        value={DiseaseName.결핵}
        disabled={!experienceDiseaseMain?.includes(DiseaseName.감염성질환)}
        multiple={true}
        readOnly={!isRegister}
      />
      <FormCheckbox
        name={MedicalHistoryChartFields.DiseaseExperience}
        text={DiseaseLabel[DiseaseName.감염성질환_A형간염]}
        labelStyle={{ color: STYLES_VARIABLES.GRAY_08, marginRight: '6px' }}
        value={DiseaseName.감염성질환_A형간염}
        disabled={!experienceDiseaseMain?.includes(DiseaseName.감염성질환)}
        multiple={true}
        readOnly={!isRegister}
      />
      <FormCheckbox
        name={MedicalHistoryChartFields.DiseaseExperience}
        text={DiseaseLabel[DiseaseName.감염성질환_B형간염]}
        labelStyle={{ color: STYLES_VARIABLES.GRAY_08, marginRight: '6px' }}
        value={DiseaseName.감염성질환_B형간염}
        disabled={!experienceDiseaseMain?.includes(DiseaseName.감염성질환)}
        multiple={true}
        readOnly={!isRegister}
      />
      <FormCheckbox
        name={MedicalHistoryChartFields.DiseaseExperience}
        text={DiseaseLabel[DiseaseName.감염성질환_에이즈]}
        labelStyle={{ color: STYLES_VARIABLES.GRAY_08, marginRight: '6px' }}
        value={DiseaseName.감염성질환_에이즈}
        disabled={!experienceDiseaseMain?.includes(DiseaseName.감염성질환)}
        multiple={true}
        readOnly={!isRegister}
      />
      <FormCheckbox
        name={MedicalHistoryChartFields.DiseaseExperience}
        text={DiseaseLabel[DiseaseName.포진]}
        labelStyle={{ color: STYLES_VARIABLES.GRAY_08, marginRight: '6px' }}
        value={DiseaseName.포진}
        disabled={!experienceDiseaseMain?.includes(DiseaseName.감염성질환)}
        multiple={true}
        readOnly={!isRegister}
      />
      <FormCheckbox
        name={MedicalHistoryChartFields.DiseaseExperience}
        text={DiseaseLabel[DiseaseName.유행성감기]}
        labelStyle={{
          color: STYLES_VARIABLES.GRAY_08,
          marginRight: '8px',
          paddingRight: '0',
        }}
        value={DiseaseName.유행성감기}
        disabled={!experienceDiseaseMain?.includes(DiseaseName.감염성질환)}
        multiple={true}
        readOnly={!isRegister}
      />
      <span
        style={{
          color: STYLES_VARIABLES.GRAY_08,
          verticalAlign: 'top',
          lineHeight: '24px',
        }}
        className="mr32"
      >
        &#93;
      </span>

      <FormCheckbox
        name={MedicalHistoryChartFields.DiseaseExperience}
        text={DiseaseLabel[DiseaseName.신장질환]}
        labelStyle={{
          fontWeight: '700',
          marginRight: '32px',
          paddingLeft: '0',
        }}
        value={DiseaseName.신장질환}
        multiple={true}
        readOnly={!isRegister}
      />

      <FormCheckbox
        name={MedicalHistoryChartFields.DiseaseExperience}
        text={DiseaseLabel[DiseaseName.신장이식]}
        labelStyle={{
          fontWeight: '700',
          marginRight: '32px',
        }}
        value={DiseaseName.신장이식}
        multiple={true}
        readOnly={!isRegister}
      />

      <FormCheckbox
        name={MedicalHistoryChartFields.DiseaseExperience}
        text={DiseaseLabel[DiseaseName.성병]}
        labelStyle={{ fontWeight: '700' }}
        value={DiseaseName.성병}
        multiple={true}
        afterChange={(value) => {
          const valueAsArray = value as string[];
          if (!valueAsArray.includes(DiseaseName.성병)) {
            const filteredValues = experienceDiseaseMain?.filter(
              (disease) =>
                disease !== DiseaseName.성병 &&
                disease !== DiseaseName.매독 &&
                disease !== DiseaseName.임질 &&
                disease !== DiseaseName.클라미디아
            );

            setValue(
              MedicalHistoryChartFields.DiseaseExperience,
              filteredValues
            );
          }
        }}
        readOnly={!isRegister}
      />

      <span
        style={{
          color: STYLES_VARIABLES.GRAY_08,
          verticalAlign: 'top',
          lineHeight: '24px',
        }}
        className="mr8"
      >
        &#91;
      </span>
      <FormCheckbox
        name={MedicalHistoryChartFields.DiseaseExperience}
        text={DiseaseLabel[DiseaseName.매독]}
        labelStyle={{
          color: STYLES_VARIABLES.GRAY_08,
          marginRight: '6px',
          paddingLeft: '0',
        }}
        value={DiseaseName.매독}
        disabled={!experienceDiseaseMain?.includes(DiseaseName.성병)}
        multiple={true}
        readOnly={!isRegister}
      />
      <FormCheckbox
        name={MedicalHistoryChartFields.DiseaseExperience}
        text={DiseaseLabel[DiseaseName.임질]}
        labelStyle={{ color: STYLES_VARIABLES.GRAY_08, marginRight: '6px' }}
        value={DiseaseName.임질}
        disabled={!experienceDiseaseMain?.includes(DiseaseName.성병)}
        multiple={true}
        readOnly={!isRegister}
      />
      <FormCheckbox
        name={MedicalHistoryChartFields.DiseaseExperience}
        text={DiseaseLabel[DiseaseName.클라미디아]}
        labelStyle={{
          color: STYLES_VARIABLES.GRAY_08,
          marginRight: '8px',
          paddingRight: '0',
        }}
        value={DiseaseName.클라미디아}
        disabled={!experienceDiseaseMain?.includes(DiseaseName.성병)}
        multiple={true}
        readOnly={!isRegister}
      />
      <span
        style={{
          color: STYLES_VARIABLES.GRAY_08,
          verticalAlign: 'top',
          lineHeight: '24px',
        }}
        className="mr32"
      >
        &#93;
      </span>

      <FormCheckbox
        name={MedicalHistoryChartFields.DiseaseExperience}
        text={DiseaseLabel[DiseaseName.기타]}
        labelStyle={{ fontWeight: '700' }}
        value={DiseaseName.기타}
        multiple={true}
        readOnly={!isRegister}
      />
    </div>
  );
};

export default DiseaseExperience;
